export default {
  'tweet': {
    'backgroundColor': '#ffffff',
    'minHeight': '51px',
    'maxWidth': '588px',
    'minWidth': '350px',
    'borderBottom': '1px solid #e6ecf0',
    'color': '#14171a',
    'fontFamily': '"Helvetica Neue", "Helvetica", "Arial", "sans-serif"',
    'fontSize': '16px',
    'lineHeight': '20px',
    'listStyleImage': 'none',
    'listStylePosition': 'outisde',
    'listStyleType': 'none',
    'padding': '1px 1px',
    'position': 'relative',
    'textAlign': 'start'
  },
  'content': {
    'marginLeft': '5px'
  },
  'context': {
    'margin': '-3px 0 3px 10px'
  },
  'accountGroup': {
    'color': '#8899a6',
    'textDecoration': 'none'
  },
  'avatar': {
    'float': 'left',
    'marginTop': '3px',
    'marginLeft': '-58px',
    'width': '40px',
    'height': '40px',
    'borderRadius': '24px',
    'border': 0
  },
  'fullname': {
    'fontWeight': 'bold',
    'color': '#14171a'
  },
  'username': {
    'direction': 'ltr',
    'unicodeBidi': 'embed',
    'fontSize': '16px',
    'color': '#657786'
  },
  's': {
    'color': '#b1bbc3',
    'textDecoration': 'none'
  },
  'b': {
    'fontWeight': 'normal'
  },
  'time': {
    'color': '#657786'
  },
  'retweet': {
    'color': '#657786',
    'fontSize': '12px',
    'lineHeight': '16.5px',
    'marginLeft': '8px'
  },
  'link': {
    'textDecoration': 'none'
  },
  'timestamp': {
    'fontSize': '12px',
    'textDecoration': 'none',
    'color': '#8899a6'
  },
  'tweetText': {
    'whiteSpace': 'pre-wrap',
    'wordWrap': 'break-word',
/*    'color': '#14171a', */
    'margin': 0
  },
  'footer': {
    'display': 'table',
    'width': '100%',
    'fontSize': '12px',
    'paddingTop': '1px'
  },
  'ProfileTweetActionList': {
    'fontSize': '0em',
    'lineHeight': '1',
    'marginTop': '10px',
    'marginBottom': '2px',
    'display': 'block'
  },
  'ProfileTweetAction': {
    'display': 'inline-block',
    'width': '80px'
  },
  'ProfileTweetActionBtn': {
    'display': 'inline-block',
    'fontSize': '16px',
    'lineHeight': '1',
    'padding': '0 2px',
    'position': 'relative',
    'border': 0,
    'background': 'transparent',
    'margin': 0,
    'WebkitAppearance': 'button',
    'cursor': 'pointer'
  },
  'ProfileTweetActionCount': {
    'color': '#657786',
    'display': 'inline-block',
    'fontSize': '12px',
    'fontWeight': 'bold',
    'marginLeft': '6px',
    'position': 'relative',
  },
  'IconContainer': {
    'display': 'inline-block',
    'verticalAlign': 'middle',
  },
  'IconTextContainer': {
    'display': 'inline-block',
  },
  'Icon': {
    'background': 'transparent',
    'display': 'inline-block',
    'fontStyle': 'normal',
    'position': 'relative',
  },
  'IconContext': {
    'background': '#77b255',
    'display': 'inline-block',
    'fontStyle': 'normal',
    'verticalAlign': 'middle',
    'position': 'relative',
    'width': '15px',
    'height': '14px',
    'fill': 'white',
    'borderRadius': '2px'
  },
  'AdaptiveMedia': {
    'display': 'inline-block',
    'maxHeight': '508px',
    'maxWidth': '508px',
    'margin': '10px 0 0 0',
    'overflow': 'hidden',
    'border': '1px solid rgba(0,0,0,0.1)',
    'borderRadius': '5px',
    'verticalAlign': 'top',
    'textAlign': 'center',
    'width': '100%'
  },
  'AdaptiveMediaBadge': {
    'background': 'rgba(0, 0, 0, 0.3)',
    'borderRadius': '3px',
    'bottom': '52px',
    'left': '80px',
    'boxSizing': 'border-box',
    'MozBoxSizing': 'border-box',
    'color': '#fff',
    'height': '20px',
    'lineHeight': '20px',
    'fontWeight': '700',
    'padding': '0 5px',
    'position': 'absolute',
    'zIndex': 1
  },
  'img': {
    'width': '100%'
  },
  'QuoteTweet': {
    'marginTop': '12px',
    'border': 'solid 1px #e6ecf0',
    'cursor': 'pointer',
    'borderRadius': '4px',
    'position': 'relative',
  },
  'QuoteTweet:hover': {
    'border': 'solid 1px aab8c2'
  },
  'QuoteLink': {
    'height': '100%',
    'left': 0,
    'position': 'absolute',
    'top': 0,
    'width': '100%'
  },
  'QuoteTweetInner': {
    'padding': '12px'
  },
  'QuoteTweetAuthor': {
    'display': 'inline-block',
    'maxWidth': '100%',
    'position': 'relative',
    'zIndex': 1
  },
  'QuoteTweetText': {
    'marginTop': '3px',
    // 'maxHeight': '78px',
    'maxWidth': '100%',
    'overflow': 'hidden',
    'whiteSpace': 'pre-wrap',
    'wordWrap': 'break-word'
  },
  'video': {
    'width': '100%',
    'verticalAlign': 'bottom',
    'maxHeight': '508px',
    'objectFit': 'contain',
    'background': '#000000'
  },
  'Modal': {
    'position': 'fixed',
    'top': 0,
    'left': 0,
    'zIndex': 999999999999,
    'overflowX': 'hidden',
    'textAlign': 'center',
    'background': 'rgba(0, 0, 0, 0.8)',
    'display': 'table',
    'width': '100%',
    'height': '100vh'
  },
  'ModalClose': {
    'position': 'fixed',
    'top': 0,
    'left': 0,
    'zIndex': 10,
    'overflowX': 'hidden',
    'textAlign': 'center',
    'display': 'table',
    'width': '100%',
    'height': '100vh'
  },
  'ModalInner': {
    'display': 'table-cell',
    'verticalAlign': 'middle',
    'position': 'relative',
    'zIndex': 20
  }
}